import axios from "axios";

const url = `${process.env.AGW_EMPLEO_SERVICES_API_URL}`;
const apikeyServices = process.env.AGW_EMPLEO_SERVICES_API_KEY;
const newTokenizer = process.env.URL_TOKENIZER;

const CONTENT_TYPE_COMENTARIO = 1;
const CONTENT_TYPE_ARTICULO = 2;
const RS_USER_MAIL = "noreply-empleo@comfama.com.co";


const getToken = async () => {
    const data = await axios.post(
        `${newTokenizer}`,
        {'action': 'getJWT'},
        {
            headers: {
                Apikey: process.env.URL_TOKENIZER_APIKEY,
                Origin: process.env.URL_TOKENIZER_ORIGIN,
                "Content-Type": "application/json",
            },
        }
    );
    return data;
};

const getSocialUserData = async (email, token) => {
    const data = await axios.get(
        `${url}comfama/red-social/api/v1/user/get-usuario`,
        { params: { "email": email },
          headers : {Authorization: token.data.data.id_token, apikey: apikeyServices }
        }
    );
    return data;
}

const saveSocialUserData = async (token, rqBody) => {
    const data = await axios.post(
        `${url}comfama/red-social/api/v1/user/save-usuario`,
        rqBody,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            }
        }
    );
    return data;
};

const saveArticulo = async (contentfulId, token) => {
    const data = await axios.post(
        `${url}comfama/red-social/api/v1/articulo/save-articulo/${contentfulId}`,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            }
        }
    );
    return data;
};

const saveVisita = async (payload, token) => {
    const data = await axios.post(
        `${url}comfama/red-social/api/v1/visitas/save-visita`,
        payload,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            }
        }
    );
    return data;
};

const getTotalsById = async (contentId, contentType, token) => {
    const data = await axios.get(
                    `${url}comfama/red-social/api/v1/contenidos/`,
                    {
                      params: { "contentId": contentId , "contentType": contentType },
                      headers : {Authorization: token.data.data.id_token, apikey: apikeyServices }
                    }
                );
    return data;
};

const saveLike = async (payload, token) => {
    const data = await axios.post(
        `${url}comfama/red-social/api/v1/likes/save-like`,
        payload,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            }
        }
    );
    return data;
};

const getLikes = async (contentId, contentType, email, token, getData?) => {
    const data = await axios.get(
                    `${url}comfama/red-social/api/v1/likes/get-likes`,
                    {
                        params: { "relContentId": contentId, "relContentType": contentType, "userEmail" : email, "getLikeData" : getData},
                        headers : {Authorization: token.data.data.id_token, apikey: apikeyServices }
                    }
                );
    return data;
};

const getLikesByPath = async (path, token) => {
    const data = await axios.get(
                    `${url}comfama/red-social/api/v1/likes/get-likes-by-path`,
                    { params: { "path" : path}, headers : {Authorization: token.data.data.id_token, apikey: apikeyServices } }
                );
    return data;
};

const getCommentsByParent = async (token, parentContentId , parentContentType) => {
    const data = await axios.get(
                    `${url}comfama/red-social/api/v1/comment/get-comments-by-parent`,
                    { params: { "parentContentId" : parentContentId, "parentContentType": parentContentType},
                      headers : {Authorization: token.data.data.id_token, apikey: apikeyServices } }
                );
    return data;
};

const getCommentsByParentPaginated = async (token, parentContentId , parentContentType, pageStart, pageSize) => {
    const data = await axios.get(
                    `${url}comfama/red-social/api/v1/comment/get-comments-by-parent-paginated`,
                    { params: { "parentContentId" : parentContentId,
                                "parentContentType": parentContentType,
                                "pageStart": pageStart,
                                "pageSize": pageSize
                            },
                    headers : {Authorization: token.data.data.id_token, apikey: apikeyServices } }
                );
    return data;
};

const saveComment = async (token, rqBody) => {
    const data = await axios.post(
        `${url}comfama/red-social/api/v1/comment/save-comentario`,
        rqBody,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices,
                'Content-Type': 'multipart/form-data'
            }
        }
    );
    return data;
};

const delComment = async (token, usermail, contentId) => {
    const data = await axios.delete(
        `${url}comfama/red-social/api/v1/comment/del-comentario/${usermail}--${contentId}`,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            }
        }
    );
    return data;
};

const editComment = async (token, rqBody) => {
    const data = await axios.patch(
        `${url}comfama/red-social/api/v1/comment/edit-comentario`,
        rqBody,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            }
        }
    );
    return data;
};

export { RS_USER_MAIL, CONTENT_TYPE_ARTICULO, CONTENT_TYPE_COMENTARIO, getToken, saveArticulo, saveVisita, getTotalsById, saveLike, getLikes, getLikesByPath, getCommentsByParent, getCommentsByParentPaginated, saveComment, getSocialUserData, saveSocialUserData, delComment, editComment };

export interface AttachmentDTO {
    id:number;
    fileName:string;
    base64File:string;
    deleteFlag:boolean;
}
 
